import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import RegenerateAlert from "../llm/RegenerateAlert";
// import DeleteTransaction from "../transactions/DeleteTransaction";



const LlmRegenrateAlert = ({ onClose, onProceed }) => {
    console.log("Onlocse----fir------", onClose)

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "llmregeneratealert" }}
        >

            {/* <DeleteTransaction onCompletion={onCompletion} onDeleteConfirmation={onDeleteConfirmation} element={element} onClose={onClose} /> */}
            <RegenerateAlert  onProceed={onProceed} onClose={handleClose} />


        </Dialog >
    )

}

export default LlmRegenrateAlert;